import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as inviteStatusState from '../static-data.reducer';
import * as inviteStatusReducer from '../reducers/invite-status.reducer';

export const selectInviteStatus = createSelector(inviteStatusState.selectInviteStatusState, inviteStatusReducer.getInviteStatus);
